import {Component, h} from 'preact'
import { IdeaStatus } from '../../control-components/ideation-status/Types'
import IdeationColumn from './pipeline/IdeationColumn'
import { Idea } from './Types'
import axios from 'axios'

interface Props {
  title: string,
  column_1: number,
  column_2: number,
  column_3: number,
  maxHeight: number,
  currentUserId: number,
  isGuest: boolean,
  onChange: (state: {title: string}) => void
}

interface State {
  ideaStatusList: Array<IdeaStatus>,
  ideasFirstCol: Array<Idea>,
  ideasSecondCol: Array<Idea>,
  ideasThirdCol: Array<Idea>
}

class Pipeline extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      ideaStatusList: [],
      ideasFirstCol: [],
      ideasSecondCol: [],
      ideasThirdCol: []
    }
  }

  getIdeationStatusTitle (ideaStatusId: number) {
    const items: Array<IdeaStatus> = this.state.ideaStatusList.filter((status: IdeaStatus) => status.id == ideaStatusId.toString())

    if (!items.length) return ''

    return items[0].name
  }

  async getIdeasByIdeationStatus (ideaStatusName: string) {

    let filters = {ideationStatus: [ideaStatusName]}

    const res = await axios.get('ideas/topics', {
      params: {
        filters,
        sort: {
          votes: 'desc'
        }
      }
    })

    if (res.data) {
      return res.data.topics
    }
    return []
  }

  async componentDidMount () {
    const { data } = await axios.get('/community/api/ideas/ideaStatuses')
    if (!data.result.length) {
      return
    }

    this.setState({ ideaStatusList: data.result })
    
    let titleFirstColumn = this.getIdeationStatusTitle(this.props.column_1)
    let ideasFirst = await this.getIdeasByIdeationStatus(titleFirstColumn)

    let titleSecondColumn = this.getIdeationStatusTitle(this.props.column_2)
    let ideasSec = await this.getIdeasByIdeationStatus(titleSecondColumn)

    let titleThirdColumn = this.getIdeationStatusTitle(this.props.column_3)
    let ideasThird = await this.getIdeasByIdeationStatus(titleThirdColumn)

    this.setState({
      ideasFirstCol: ideasFirst,
      ideasSecondCol: ideasSec,
      ideasThirdCol: ideasThird
    })
  }

  render (
    { title, column_1, column_2, column_3, maxHeight, currentUserId, isGuest }: Props,
    { ideasFirstCol, ideasSecondCol, ideasThirdCol }: State
  ) {
    return (
      <section class='full-width Template-brand-featured pipeline__widget'>
        <div class='sitewidth'>
          <div class='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <div className='pipeline-col-list' style={{'max-height': maxHeight}}>
              <IdeationColumn 
                ideaStatusTitle={this.getIdeationStatusTitle(column_1)}
                ideaList={ideasFirstCol}
                maxHeight={maxHeight}
                currentUserId={currentUserId}
                isGuest={isGuest}
                />
              <IdeationColumn 
                ideaStatusTitle={this.getIdeationStatusTitle(column_2)}
                ideaList={ideasSecondCol}
                maxHeight={maxHeight}
                currentUserId={currentUserId}
                isGuest={isGuest}
                />
              <IdeationColumn 
                ideaStatusTitle={this.getIdeationStatusTitle(column_3)}
                ideaList={ideasThirdCol}
                maxHeight={maxHeight}
                currentUserId={currentUserId}
                isGuest={isGuest}
                />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Pipeline
